export const ON_CONVERSATION_CREATE_EVENT_TYPE = 'onConversationCreate';
export const ON_MESSAGE_SENT_EVENT_TYPE = 'onMessageSent';
export const ON_MESSAGE_RECEIVED_EVENT_TYPE = 'onMessageReceived';
export const ON_UNREAD_COUNT_CHANGE_EVENT_TYPE = 'onUnreadCountChange';
export const ON_CONVERSATION_ENDED_EVENT_TYPE = 'onConversationEnded';
export const ON_ASSISTANT_ENDED_EVENT_TYPE = 'onAssistantEnded';
export const ON_CONVERSATION_UNENDED_EVENT_TYPE = 'onConversationUnended';
export const ON_SATISFACTION_RECEIVED_EVENT_TYPE = 'onSatisfactionReceived';
export const ON_AGENT_TYPING_ACTIVITY = 'onAgentTypingActivity';
export const ON_CONVERSATION_MERGED_EVENT_TYPE = 'onConversationMerged';
export const ON_CUSTOMER_DELETE_EVENT_TYPE = 'onCustomerDelete';
export const ON_CONVERSATION_DELETED_EVENT_TYPE = 'onConversationDeleted';
export const ON_SESSION_TITLE_CHANGED_EVENT_TYPE = 'onSessionTitleChanged';
export const ON_URL_PREVIEW_RECEIVED_EVENT_TYPE = 'onUrlPreviewReceived';
export const ON_LOGIN = 'onLogin';
export const ON_LOGOUT = 'onLogout';
export const POLLING_INTERVAL_HEADER_KEY =
  'x-kustomer-chat-messages-global-poller';
export const DEFAULT_HISTORICAL_MESSAGE_PAGE_SIZE = 25;
export const DEFAULT_PUBNUB_MESSAGE_PAGE_SIZE = 100;
export const PUBNUB_MAX_CHANNELS_COUNT = 100;
